import { render, staticRenderFns } from "./SkillsNotConnectedWithCompetencesTab.vue?vue&type=template&id=72953982&scoped=true&"
import script from "./SkillsNotConnectedWithCompetencesTab.vue?vue&type=script&lang=js&"
export * from "./SkillsNotConnectedWithCompetencesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72953982",
  null
  
)

export default component.exports